import { ReactNode, useState } from 'react';

import SignInContext from './SignInContext';

interface Props {
    children?: ReactNode;
}

function SignInContextProvider({ children }:Props) {
  const useVerified = useState<boolean>(false);
  const usePhoneNo = useState<string>('');
  const useInputPhoneNo = useState<string>('');
  const useInputSmsAuthCode = useState<string>('');
  return (
      <SignInContext value={{
        useVerified,
        usePhoneNo,
        useInputPhoneNo,
        useInputSmsAuthCode,
      }}>
          {children}
      </SignInContext>
  );
}

export default SignInContextProvider;
